var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSongbitsWithoutText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 19,
    viewBox: "0 0 43 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5001 18.4946C21.8831 18.4946 22.1936 18.0803 22.1936 17.5691L22.1936 0.925507C22.1936 0.414366 21.8831 3.82023e-06 21.5001 3.82705e-06C21.117 3.83387e-06 20.8065 0.414366 20.8065 0.925507L20.8065 17.5691C20.8065 18.0803 21.117 18.4946 21.5001 18.4946Z",
    fill: "#FFD600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9676 18.4946C25.4783 18.4946 25.8923 18.0806 25.8923 17.5699L25.8923 6.47312C25.8923 5.96241 25.4783 5.54839 24.9676 5.54839C24.4569 5.54839 24.0429 5.96241 24.0429 6.47312L24.0429 17.5699C24.0429 18.0806 24.4569 18.4946 24.9676 18.4946Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0322 18.4946C17.5214 18.4946 17.1074 18.0803 17.1074 17.5691L17.1074 0.925507C17.1074 0.414366 17.5214 3.82207e-06 18.0322 3.83117e-06C18.5429 3.84026e-06 18.9569 0.414366 18.9569 0.925507L18.9569 17.5691C18.9569 18.0803 18.5429 18.4946 18.0322 18.4946Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6666 18.4946C29.1773 18.4946 29.5913 18.0793 29.5913 17.567L29.5913 4.62656C29.5913 4.11424 29.1773 3.69893 28.6666 3.69893C28.1559 3.69893 27.7418 4.11424 27.7418 4.62656L27.7418 17.567C27.7418 18.0793 28.1559 18.4946 28.6666 18.4946Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3332 18.4946C13.8225 18.4946 13.4084 18.0599 13.4084 17.5237L13.4084 9.75592C13.4084 9.21967 13.8225 8.78495 14.3332 8.78495C14.8439 8.78495 15.2579 9.21967 15.2579 9.75592L15.2579 17.5237C15.2579 18.0599 14.8439 18.4946 14.3332 18.4946Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3656 18.4946C32.8763 18.4946 33.2903 18.0806 33.2903 17.5699L33.2903 11.0968C33.2903 10.5861 32.8763 10.172 32.3656 10.172C31.8548 10.172 31.4408 10.5861 31.4408 11.0968L31.4408 17.5699C31.4408 18.0806 31.8548 18.4946 32.3656 18.4946Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6344 18.4946C10.1237 18.4946 9.70972 18.0786 9.70972 17.5655L9.70972 6.47755C9.70972 5.96439 10.1237 5.54839 10.6344 5.54839C11.1452 5.54839 11.5592 5.96439 11.5592 6.47755L11.5592 17.5655C11.5592 18.0786 11.1452 18.4946 10.6344 18.4946Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0645 18.4946C36.5752 18.4946 36.9893 18.0634 36.9893 17.5314L36.9893 7.89875C36.9893 7.36676 36.5752 6.93549 36.0645 6.93549C35.5538 6.93549 35.1398 7.36676 35.1398 7.89875L35.1398 17.5314C35.1398 18.0634 35.5538 18.4946 36.0645 18.4946Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.93547 18.4946C6.42476 18.4946 6.01074 18.0806 6.01074 17.5699L6.01074 15.7204C6.01074 15.2097 6.42476 14.7957 6.93547 14.7957C7.44619 14.7957 7.8602 15.2097 7.8602 15.7204L7.8602 17.5699C7.8602 18.0806 7.44619 18.4946 6.93547 18.4946Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7635 18.4946C40.2742 18.4946 40.6882 18.1151 40.6882 17.647L40.6882 14.2563C40.6882 13.7881 40.2742 13.4086 39.7635 13.4086C39.2528 13.4086 38.8388 13.7881 38.8388 14.2563L38.8388 17.647C38.8388 18.1151 39.2528 18.4946 39.7635 18.4946Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2365 18.4946C2.72578 18.4946 2.31177 18.0806 2.31177 17.5699L2.31177 11.0968C2.31177 10.5861 2.72578 10.172 3.2365 10.172C3.74721 10.172 4.16123 10.5861 4.16123 11.0968L4.16123 17.5699C4.16123 18.0806 3.74721 18.4946 3.2365 18.4946Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSongbitsWithoutText);
export default __webpack_public_path__ + "static/media/songbits-without-text.fa7afdbcfca6cc791815c86028234870.svg";
export { ForwardRef as ReactComponent };